<template>
  <input
    v-if="type === 'submit' && !loadingSpinner"
    id="submit-button"
    class="font-normal"
    type="submit"
    :value="value"
    :disabled="disabled || loadingSpinner"
    :autofocus="autoFocus"
  />

  <div
    v-if="loadingSpinner"
    style="background: #fdf1c5; position: relative; display: inline-table"
  >
    <div class="m-auto w-max" />
    <svg
      :class="`loading-${variant}`"
      class="-top-2px loading relative h-5 w-full"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 16C28 18.3734 27.2962 20.6935 25.9776 22.6668C24.6591 24.6402 22.7849 26.1783 20.5922 27.0866C18.3995 27.9948 15.9867 28.2324 13.6589 27.7694C11.3311 27.3064 9.19295 26.1635 7.51472 24.4853C5.83649 22.8071 4.6936 20.6689 4.23058 18.3411C3.76755 16.0133 4.00519 13.6005 4.91345 11.4078C5.8217 9.21509 7.35977 7.34094 9.33316 6.02236C11.3065 4.70379 13.6266 4 16 4"
        stroke="currentColor"
        stroke-width="3"
      />
      <path
        d="M16 1V7L20 4L16 1Z"
        fill="currentColor"
      />
      <path
        d="M22.4895 7.161C24.4444 8.50678 25.9564 10.402 26.8342 12.6071"
        stroke="currentColor"
        stroke-width="3"
      />
    </svg>
  </div>
  <button
    v-if="type !== 'submit'"
    class="w-full cursor-pointer rounded-md border border-gray-over-dark bg-white text-1md font-normal text-gray-over-dark md:w-auto"
    :class="variant"
    :disabled="disabled || isLoading"
    :style="style"
    :type="type"
    @click="clickMe"
  >
    <slot v-if="!isLoading" />
    <svg
      v-else
      :class="`loading-${variant}`"
      class="-top-2px loading relative h-5 w-full"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 16C28 18.3734 27.2962 20.6935 25.9776 22.6668C24.6591 24.6402 22.7849 26.1783 20.5922 27.0866C18.3995 27.9948 15.9867 28.2324 13.6589 27.7694C11.3311 27.3064 9.19295 26.1635 7.51472 24.4853C5.83649 22.8071 4.6936 20.6689 4.23058 18.3411C3.76755 16.0133 4.00519 13.6005 4.91345 11.4078C5.8217 9.21509 7.35977 7.34094 9.33316 6.02236C11.3065 4.70379 13.6266 4 16 4"
        stroke="currentColor"
        stroke-width="3"
      />
      <path
        d="M16 1V7L20 4L16 1Z"
        fill="currentColor"
      />
      <path
        d="M22.4895 7.161C24.4444 8.50678 25.9564 10.402 26.8342 12.6071"
        stroke="currentColor"
        stroke-width="3"
      />
    </svg>
  </button>
</template>

<script>
export default {
  name: 'ButtonIcon',
  props: {
    variant: {
      type: String,
      default: 'primary',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'button',
    },
    value: String,
    class: String,
    style: Object,
    autoFocus: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    loadingSpinner: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  computed: {
    // buttonSize() {
    //   switch (this.size) {
    //     case 'xs':
    //       return "btn-size-xs"
    //     case 'md':
    //       return "btn-size-md"
    //     case '2md':
    //       return "btn-size-2md"
    //     default:
    //       return 'btn-size-lg';
    //   }
    // },
    // combinedClass() {
    //   return this.variant + " " + this.class + " " + " " + this.buttonSize;
    // },
  },
  methods: {
    clickMe() {
      this.$emit('click');
    },
  },
};
</script>
<style scoped>
.tertiary {
  @apply w-full cursor-pointer rounded-md bg-off-white text-gray-over-dark;
}

button:disabled,
input:disabled {
  @apply bg-light-gray !important;
}

.primary {
  @apply inline-block cursor-pointer rounded-md border border-yellow-500 bg-yellow-500 text-1md text-white;
}

.primary:hover {
  @apply bg-light-orange !important;
}

.primary:focus {
  @apply bg-dark-orange !important;
}

.primary:disabled {
  @apply border-light-gray bg-light-gray !important;
}

.secondary {
  @apply inline-block cursor-pointer rounded-md border border-gray-over-dark bg-white text-1md text-gray-over-dark;
}

.secondary:hover {
  @apply border-body-color text-body-color !important;
}

.secondary:focus {
  @apply border-dark-gray text-dark-gray !important;
}

.secondary:disabled {
  @apply border-light-gray bg-white text-light-gray !important;
}

.quaternary {
  @apply w-full cursor-pointer rounded-md bg-body-color text-white;
}
.quaternary:hover {
  @apply w-full cursor-pointer rounded-md bg-dark-gray text-white;
}
.quaternary:active {
  @apply w-full cursor-pointer rounded-md bg-dark-blue text-white;
}

.btn-size-xs {
  @apply w-auto p-1 text-xxs !important;
  height: max-content !important;
}

.btn-size-md {
  @apply w-auto p-2 !important;
  height: max-content !important;
}

.btn-size-2md {
  @apply w-auto !important;
  padding: 15px 14px;
  height: max-content !important;
}

.btn-size-lg {
  padding: 15px 24px;
  @apply text-1md !important;
}

.loading-primary {
  @apply text-white;
}

.loading-secondary {
  @apply text-light-gray;
}

.loading-quaternary {
  @apply text-white;
}

.link {
  @apply cursor-pointer p-0 !important;
}

.iconary {
  @apply inline-block cursor-pointer rounded-md border border-gray-over-dark bg-white text-1md text-gray-over-dark !important;
}

.iconary:hover {
  @apply border-body-color text-body-color !important;
}

.iconary:focus {
  @apply border-dark-gray text-dark-gray !important;
}

.iconary:disabled {
  @apply border-light-gray bg-white text-light-gray !important;
}
</style>
